export default __webpack_public_path__ + "static/media/not-found.6f9ef271.png";